module.exports = __webpack_public_path__ + "img/seccion2.1.ef355808.png";